export default class Scrolly {
    /**
     * constructoe a des variables
     * @param {this} element - contient un element html
     * @param {this} options - contient les options 
     * 
     */
  constructor(element) {
    this.element = element;
    this.options = {
      rootMargin: '0px',
    };
    this.init();
  }

    /**
     * init recoit les elements qui sont vues dans la fenetres
     * @param {this} options - verifie si les elements on le data scrolly et les envoient vers la methode observe
     * 
     */
  init() {
    const observer = new IntersectionObserver(
      this.watch.bind(this),
      this.options
    );
    const items = this.element.querySelectorAll('[data-scrolly]');
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      observer.observe(item);
    }
  }

    /**
     * watch ajoute la classe d etat si l element est dans la fenetre et regarde si l animation doit etre fait une seul fois
     * @param {const} entry - recoit l informations qu un elent est entre ou sortie de la fenetre
     * @param {const} target - contient les elements dans la fenetre
     * 
     */
  watch(entries, observer) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;

      if (entry.isIntersecting) {
        target.classList.add('is-active');

        if ('noRepeat' in target.dataset) {
          observer.unobserve(element);
        }
      } else {
        target.classList.remove('is-active');
      }
    }
  }
}
